import { IYMPropsParams, IYMParams } from "./interfaces";

declare global {
  export interface Window {
    [key: string]: any;
  }
}

export function sendYMEvent(
  counterId: string,
  action: string,
  params: IYMPropsParams, // label
  categoryPostfix = "",
  // yandexAdditional
  verbose?: boolean // settings.verbose
) {
  const YMCounterId: string = `yaCounter${counterId}`; // settings.analytics.ym.clientCounterId

  const isDebugMode = window.location.search.search("_ym_debug") >= 0;

  if (!window[YMCounterId] && !isDebugMode) {
    return;
  }

  // TODO: take only needed params and change theirs names
  const ymParams: IYMParams = deleteEmptyFields({
    embedID: params.embedId,
    gallery: params.galleryId,
    sku: params.skuId,
    skuGId: params.skuGroupId,
    categoryId: params.categoryId,
    tagCode: params.tagCode,
    fbProduct: params.fbProduct,
    provPostId: params.provPostId,
    igCode: params.igCode,
    linklabel: params.linklabel,
    linkUrl: params.linkUrl,
    stock: params.stock,
    frUId: params.frUId,

    items: params.items?.map((item) => {
      return {
        item_name: item.title,
        item_article: item.sku?.vendorCode,
        item_offerId: item.sku?.offerId,
        item_groupId: item.sku?.groupId,
      };
    }),
  });

  const prefix = "Frisbuy";

  if (isDebugMode) {
    verboseCallback(
      YMCounterId,
      prefix + action + categoryPostfix,
      ymParams,
      true
    );

    if (!window[YMCounterId]) {
      console.error(
        `Object 'window[${YMCounterId}]' is ${typeof window[YMCounterId]}`
      );
      return;
    }
  }

  switch (action) {
    case "AddToFavorite":
      window[YMCounterId].reachGoal("ym-add-to-wishlist", ymParams, () =>
        verboseCallback(YMCounterId, "ym-add-to-wishlist", ymParams, verbose)
      );
      break;
    default:
      // NOTE: idk what is it. I copy it from "/common/mixins/analytics.ts" and comment
      // if (yandexAdditional) {
      //   yandexAdditional(ymParams);
      // }

      window[YMCounterId].reachGoal(
        `${prefix + action + categoryPostfix}`,
        ymParams,

        () =>
          verboseCallback(
            YMCounterId,
            `${prefix + action + categoryPostfix}`,
            ymParams,
            verbose
          )
      );
  }
}

function verboseCallback(
  YMCounterId: string,
  action: string,
  ymParams: IYMParams,
  verbose?: boolean
) {
  if (!verbose) return;

  console.log(
    `%c${YMCounterId}.push ${action}`,
    "background-color: yellow; color: red; font-size: 16px; border-radius: 4px; padding: 2px 4px;",
    ymParams
  );
}

function deleteEmptyFields(object: { [key: string | number | symbol]: any }) {
  for (const field in object) {
    if (
      !object[field] &&
      typeof object[field] !== "number" &&
      typeof object[field] !== "boolean"
    ) {
      delete object[field];
    }
  }

  return object;
}
